module.exports = __webpack_public_path__ + "static/schoolsforasia_activity1@2x-2c0266ce67aeac15f126a2e0a5e02b86.png";